import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faPlus, faSave, faArrowLeft, faArrowRight, faBroom } from '@fortawesome/free-solid-svg-icons';
import './OffloadDetails.css'
import { Tooltip } from 'react-tooltip';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import GoCast from '../../Images/GoCast.png'
//////////////////////////////////////////////////////////

const OffloadDetails = () => {

    ///////////////// Navigation ///////////////////////

    const navigate = useNavigate();

    const GoBack = () => {
        navigate(-1); // Navigates back to the previous page
    };

    const [isLoading, setIsLoading] = useState(false); // Loading GIF


    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const Key2 = queryParams.get('Key2');
    const Key3 = queryParams.get('Key3');
    const Key4 = queryParams.get('Key4');
    const Key5 = queryParams.get('Key5');
    const Company = queryParams.get('Company');
    // Returns Dynamic Parameter from TruckForm :truckId
    const { offloadID } = useParams();

    // Option Panel visibility
    const [panel1Visible, setPanel1Visible] = useState(true);
    // Advanced Panel visibility
    const [panel2Visible, setPanel2Visible] = useState(true);

    // Date Picker

    const [selectedDate, setSelectedDate] = useState(null);

    const handleChange = (date) => setSelectedDate(date);
    //        API CODE FOR Form
    const [formApiData, setFormApiData] = useState({});
    const [truckApiData, setTruchApi] = useState([]);
    const [selectedTruck, setSelectedTruck] = useState('');
    const [resourceApiData, setResourceApiData] = useState([]);
    //        API CODE
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed

    //       UPDATE 
    const [modifiedData, setModifiedData] = useState({});

    const fetchData = async () => {
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrlGRID = `https://77.92.189.102/iitprecastvertical/api/v1/Ice.BO.UD103Svc/UD103As?$filter= Key1 eq '${offloadID}'`
        const apiUrlFORM = `https://77.92.189.102/iitprecastvertical/api/v1/Ice.BO.UD103Svc/UD103s(${Company},${offloadID},,,,)`;

        try {
            ////////////////////////// Form Data /////////////////////////////////
            const resp = await fetch(apiUrlFORM, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!resp.ok) {
                throw new Error('Network response was not ok');
            }
            const formData = await resp.json();
            setFormApiData(formData); // Set the state with the response object directly

            /////////////////////////// Table Grid Data /////////////////////////////
            const response = await fetch(apiUrlGRID, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData(data.value);
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []); // Fetch data on component mount

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = apiData.slice(startIndex, endIndex);

        return currentItems.map((item, index) => (
            <tr key={index}>
                <td>{item.Key1}</td>
                <td>{item.ChildKey1}</td>
                <td>{item.Character01}</td>
                <td>{item.Character02}</td>
                <td>{item.Character03}</td>
                <td>{item.Character04}</td>
                <td>{item.Number01}</td>
                <td>
                    <input
                        type="checkbox"
                        checked={item.CheckBox02 ? 'true' : ''}
                    />
                </td>
                <td>
                    <input
                        type="checkbox"
                        checked={item.CheckBox07 ? 'true' : ''}
                    />
                </td>
                <td>{item.ShortChar07}</td>
                <td>{item.GlobalUD103A}</td>
                <td>{item.GlobalLock}</td>
            </tr>
        ));
    };
    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    //  Update 
    const saveData = async () => {
        setIsLoading(true); // Load GIF
        const username = 'manager';
        const password = 'manager';
        const apiUrl = `https://77.92.189.102/iitprecastvertical/api/v1/Ice.BO.UD103Svc/UD103s(${Company},${offloadID},,,,)`;

        try {
            const response = await axios.patch(apiUrl, modifiedData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });
            console.log('Data saved successfully:', response.data);
            setIsLoading(false); // Load GIF
        } catch (error) {
            console.error('Error:', error.message);
        }
    };

    const handleInputChange = (e, field) => {
        const newValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setModifiedData(prevState => ({
            ...prevState,
            [field]: newValue
        }));
    };

    // Toggle Option Panel visibility
    const togglePanel1Visibility = () => {
        setPanel1Visible(!panel1Visible);
    }
    // Toggle Advanced Panel visibility
    const togglePanel2Visibility = () => {
        setPanel2Visible(!panel2Visible);
    }



    return (
        <div className='card panelcard'>
            <div className='DetailsForm'>
                <div className="card-header">
                    <button type="button" className="toggle-table-icon" onClick={GoBack}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    <h2 className='panel-title-report'>Stock Offload</h2>
                    <div className='ctrl-btns-report'>
                        <button className="btn" id='Add'>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                        <Tooltip
                            anchorSelect="#Add"
                            content="Add"
                            place='bottom'
                        />
                        <button className="btn" id='Save'>
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <Tooltip
                            anchorSelect="#Save"
                            content="Save"
                            place='bottom'
                        />
                        <button className="btn" id='Clear'>
                            {/* <FontAwesomeIcon icon={faBroom} /> */}
                            <svg className='myBroom' width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white" stroke-width="0.744">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M22.4524 1.92267C22.7452 2.21557 22.7452 2.69044 22.4524 2.98333L16.1393 9.29634C15.9927 9.11579 15.8353 8.94105 15.6673 8.77297C15.4768 8.58252 15.2778 8.40582 15.0715 8.24289L21.3917 1.92267C21.6846 1.62978 22.1595 1.62978 22.4524 1.92267Z" fill="#000"></path>
                                    <path d="M15.0277 9.34728C12.7822 7.10177 9.14153 7.10177 6.89601 9.34728L6.65198 9.59131L14.7837 17.723L15.0277 17.479C17.2733 15.2335 17.2733 11.5928 15.0277 9.34728Z" fill="#000"></path>
                                    <path d="M1.8838 12.9659L5.49664 10.5573L13.8177 18.8784L11.4091 22.4912C11.2845 22.6782 11.0826 22.7994 10.859 22.8215C10.6354 22.8437 10.4137 22.7644 10.2548 22.6055L1.76949 14.1202C1.61061 13.9613 1.53133 13.7396 1.55347 13.516C1.57561 13.2924 1.69684 13.0905 1.8838 12.9659Z" fill="#000"></path>
                                </g>
                            </svg>
                        </button>
                        <Tooltip
                            anchorSelect="#Clear"
                            content="Clear Form"
                            place='bottom'
                        />

                    </div>
                </div>
                {/* Panel 1  */}
                <div className="card-body">
                    <div className="card-header">
                        <button type="button" className="toggle-table-icon" onClick={togglePanel1Visibility}>
                            <FontAwesomeIcon icon={panel1Visible ? faArrowDown : faArrowUp} />
                        </button>
                        <h5 className='card-body-title'>
                            Details
                        </h5>
                    </div>
                    {panel1Visible && (
                        <div class="table-responsive-md">
                            <div className='TruckForm'>
                                <form>
                                    <div class="row row1">
                                        <div class="col-3 leftCol">
                                            <div class="label-input-box">
                                                <label>Load</label>
                                                <input type="text" autocomplete="off" id="endDate" name="daterange" class="Elementidinput-report" defaultValue={formApiData.Key1} />
                                            </div>
                                            <div class="label-input-box">
                                                <label>Project ID</label>
                                                <select
                                                    className="Elementidinput-report" type="text" name="optionlist" disabled="true"
                                                    onChange={(e) => console.log(e.target.value)}
                                                >
                                                    <option value="" selected disabled></option>
                                                    <option>Hold</option>
                                                    <option>Cancelld</option>
                                                </select>
                                            </div>
                                            <div class="label-input-box">
                                                <label>To</label>
                                                <select
                                                    className="Elementidinput-report" type="text" name="optionlist" disabled="true"
                                                    onChange={(e) => console.log(e.target.value)}
                                                >
                                                    <option value="" selected disabled></option>
                                                    <option>Hold</option>
                                                    <option>Cancelld</option>
                                                </select>
                                            </div>
                                            <div class="label-input-box">
                                                <label>From</label>
                                                <select
                                                    className="Elementidinput-report" type="text" name="optionlist" disabled="true"
                                                    onChange={(e) => console.log(e.target.value)}
                                                >
                                                    <option value="" selected disabled></option>
                                                    <option>Hold</option>
                                                    <option>Cancelld</option>
                                                </select>
                                            </div>
                                            <div class="label-input-box">
                                                <label>Bin</label>
                                                <select
                                                    className="Elementidinput-report" type="text" name="optionlist" disabled="true"
                                                    onChange={(e) => console.log(e.target.value)}
                                                >
                                                    <option value="" selected disabled></option>
                                                    <option>Hold</option>
                                                    <option>Cancelld</option>
                                                </select>
                                            </div>

                                        </div>
                                        <div class="col-3 midCol">
                                            <div class="label-input-box">
                                                <label>Load Status</label>
                                                <input type="text" autocomplete="off" class="Elementidinput-report" defaultValue={formApiData.ShortChar03} />
                                            </div>
                                            <div class="label-input-box">
                                                <label>Load Date</label>
                                                <input type="date" autocomplete="off" class="Elementidinput-report" defaultValue={formApiData.Date01 ? new Date(formApiData.Date01).toISOString().split('T')[0] : ''} />
                                            </div>
                                            <div class="label-input-box">
                                                <label>Site ID</label>
                                                <select
                                                    className="Elementidinput-report" type="text" name="optionlist" disabled="true"
                                                    onChange={(e) => console.log(e.target.value)}
                                                >
                                                    <option value="" selected disabled></option>
                                                    <option>Hold</option>
                                                    <option>Cancelld</option>
                                                </select>
                                            </div>
                                            <div class="label-input-box">
                                                <label>PO</label>
                                                <select
                                                    className="Elementidinput-report" type="text" name="optionlist" disabled="true"
                                                    onChange={(e) => console.log(e.target.value)}
                                                >
                                                    <option value="" selected disabled></option>
                                                    <option>Hold</option>
                                                    <option>Cancelld</option>
                                                </select>
                                            </div>
                                            <div class="label-input-box">
                                                <label>PO Line</label>
                                                <select
                                                    className="Elementidinput-report" type="text" name="optionlist" disabled="true"
                                                    onChange={(e) => console.log(e.target.value)}
                                                >
                                                    <option value="" selected disabled></option>
                                                    <option>Hold</option>
                                                    <option>Cancelld</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-3 rightColForm">

                                            <div className='loadTypeCont'>
                                                <label className='chkbox-title' >Load Type :</label>
                                                <div className='chkbox-container'>
                                                    <input class="form-check-input " type="radio" id="Delivery_Trip1" name='Delivery_Trip' />
                                                    <label class="form-check-label " for="Delivery_Trip1">Delivery Trip
                                                    </label>
                                                </div>
                                                <div className='chkbox-container'>
                                                    <input class="form-check-input " type="radio" id="Delivery_Trip2" name='Delivery_Trip' />
                                                    <label class="form-check-label " for="Delivery_Trip2">Retrurn Trip
                                                    </label>
                                                </div>

                                            </div>
                                            <div className='loadTypeCont'>
                                                <label className='chkbox-title' >Load Condition :</label>
                                                <div className='chkbox-container'>
                                                    <input class="form-check-input " type="radio" id="Load_Condition1" name='Load_Condition' />
                                                    <label class="form-check-label " for="Load_Condition1">External Supply</label>
                                                </div>
                                                <div className='chkbox-container'>
                                                    <input class="form-check-input " type="radio" id="Load_Condition2" name='Load_Condition' />
                                                    <label class="form-check-label " for="Load_Condition2">Internal Truck</label>
                                                </div>
                                                <div className='chkbox-container'>
                                                    <input class="form-check-input " type="radio" id="Load_Condition2" name='Load_Condition' />
                                                    <label class="form-check-label " for="Load_Condition2">Ex-Factory</label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="row row2">
                                        <span>
                                            <label className='section-title'>Truck Details</label>
                                        </span>
                                        <div class="col-3 leftCol">
                                            <div className="label-input-box">
                                                <label>Truck ID</label>
                                                <select
                                                    className="Elementidinput-report" type="text"
                                                    name="optionlist"

                                                >
                                                    {truckApiData.map((option, index) => (
                                                        <option key={index} value={option.UD102_Key1}>{option.UD102_Character01}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="label-input-box">
                                                <label>Plate NO</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.ShortChar07} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Driver Name</label>
                                                <select
                                                    className="Elementidinput-report" type="text" name="optionlist" disabled="true"
                                                    onChange={(e) => console.log(e.target.value)}
                                                >
                                                    <option>{formApiData.Character02}</option>
                                                </select>
                                            </div>
                                            <div className="label-input-box">
                                                <label>Capacity</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Number06} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Length</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Number10} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Volume</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.Number07} />
                                            </div>
                                            <div className="label-input-box">
                                                <label>Foreman / In charge</label>
                                                <input type="text" autocomplete="off" className="Elementidinput-report" defaultValue={formApiData.EmployeeID_c} onChange={(e) => handleInputChange(e, 'EmployeeID_c')} />
                                            </div>


                                        </div>
                                        <div class="col-3 midCol">
                                            <div class="label-input-box">
                                                <label>Resource ID</label>
                                                <input type="text" autocomplete="off" class="Elementidinput-report" defaultValue={formApiData.Character09} />
                                            </div>
                                            <div class="label-input-box">
                                                <label>Description</label>
                                                <input type="text" autocomplete="off" class="Elementidinput-report" defaultValue={formApiData.Character01} />
                                            </div>
                                            <div class="label-input-box">
                                                <label>Driver Mobile</label>
                                                <input type="text" autocomplete="off" class="Elementidinput-report" defaultValue={formApiData.Character03} />
                                            </div>
                                            <div class="label-input-box">
                                                <label>Loaded:</label>
                                                <input type="text" autocomplete="off" class="Elementidinput-report" defaultValue={formApiData.Number01} />
                                            </div>
                                            <div class="label-input-box">
                                                <label>Volume:</label>
                                                <input type="text" autocomplete="off" class="Elementidinput-report" defaultValue={formApiData.Number07} />
                                            </div>
                                            <div class="label-input-box">
                                                <label>Height:</label>
                                                <input type="text" autocomplete="off" class="Elementidinput-report" defaultValue={formApiData.Number08} />
                                            </div>

                                        </div>
                                        <div class="col-3 rightColAdditional">
                                            <div class="label-input-box">
                                                <label>Comments</label>
                                                <input type="text" autocomplete="off" class="Elementidinput-report" defaultValue={formApiData.Comments_c} />
                                            </div>
                                            <div class="label-input-box">
                                                <label>Offload Date:</label>
                                                <input type="date" autocomplete="off" class="Elementidinput-report" defaultValue={formApiData.Date02 ? new Date(formApiData.Date02).toISOString().split('T')[0] : ''} />
                                            </div>


                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
                {/* Panel 2 */}
                <div className="card-body">
                    <div className="card-header">
                        <button type="button" className="toggle-table-icon" onClick={togglePanel2Visibility}>
                            <FontAwesomeIcon icon={panel2Visible ? faArrowDown : faArrowUp} />
                        </button>
                        <h5 className='card-body-title-h5'>
                            Stock Offloading
                        </h5>
                        <div className='ctrl-btns-report'>
                            <button className="btn" id='Add'>
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                            <Tooltip
                                anchorSelect="#Add"
                                content="Add"
                                place='bottom'
                            />
                            <button className="btn" id='Save'>
                                <FontAwesomeIcon icon={faSave} />
                            </button>
                            <Tooltip
                                anchorSelect="#Save"
                                content="Save"
                                place='bottom'
                            />
                            <button className="btn" id='Clear'>
                                <FontAwesomeIcon icon={faBroom} />
                            </button>
                            <Tooltip
                                anchorSelect="#Clear"
                                content="Clear Form"
                                place='bottom'
                            />
                        </div>
                    </div>
                    {panel2Visible && (
                        <div class="table-responsive-md">
                            <div className='DetailsForm'>
                                <div class="table-responsive">
                                    <div className="scrollable-table-body">
                                        <table className="table table-bordered">
                                            {/* Table content */}
                                            <thead className='table-primary'>
                                                <tr className='bg-primary text-white'>
                                                    <th>Load No</th>
                                                    <th>Line No</th>
                                                    <th>Part Number</th>
                                                    <th>Element ID</th>
                                                    <th>From Warehouse</th>
                                                    <th>From Bin</th>
                                                    <th>Quantity</th>
                                                    <th>CheckBox02</th>
                                                    <th>CheckBox07</th>
                                                    <th>UOM</th>
                                                    <th>GlobalUD103A</th>
                                                    <th>GLobalLock</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {renderTableRows()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pagination">
                                <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </button>
                                <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </button>
                            </div>

                        </div>
                    )}
                </div>
            </div>
        </div>

    );
};

export default OffloadDetails;